import { useLocation, Navigate } from 'react-router-dom';
import { currentAuthenticatedUser, useAuth } from './useAuth';

function RequireAuth({ children }: { children: JSX.Element }): JSX.Element {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.user) {
    const user = currentAuthenticatedUser();
    user.read();
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireAuth;
